import screenLock from '../__utils/lockScroll';

const $ = jQuery.noConflict();
const ACTIVE_CLASS = 'active';

class TeamPopup {
	constructor() {
		this.popupTrigger = $( '.people-card' );
		this.popupWrappers = $( '.block-meet-team__popup' );
		this.popupClose = $( '.block-meet-team__popup-close' );
	}

	init() {
		if ( ! $( '.block-meet-team' ).length ) {
			return;
		}
		this.bindEvents();
	}
	bindEvents() {
		this.popupTrigger.on( 'click', this.openPopup );
		this.popupClose.on( 'click', this.closePopup );

		$(function() {
			$('.block-meet-team__popup-wrapper').swipe( {
				swipeRight:function(event, direction, distance, duration, fingerCount) {
					screenLock.unlock();
					$( this )
						.closest( '.block-meet-team__popup' )
						.removeClass( ACTIVE_CLASS );
				},
				threshold:30
			});
		});
	}

	openPopup( e ) {
		e.preventDefault();
		screenLock.lock();
		const key = $( this ).data( 'key' );
		const parent = $( this ).closest( '.block-meet-team' );
		const popupWrapper = parent.find(`.block-meet-team__popup[data-key="${ key }"]` );
		popupWrapper.addClass( ACTIVE_CLASS );
	}

	closePopup() {
		screenLock.unlock();
		$( this )
			.closest( '.block-meet-team__popup' )
			.removeClass( ACTIVE_CLASS );
	}

	keyDown( e ) {
		if ( e.keyCode === 27 && this.popupWrappers.hasClass( ACTIVE_CLASS ) ) {
			screenLock.unlock();
			this.popupWrappers.removeClass( ACTIVE_CLASS );
		}
	}

	outsideClick( e ) {
		if ( ! $( e.target ).closest( '.block-meet-team__popup-wrapper' ).length && this.popupWrappers.hasClass( ACTIVE_CLASS ) ) {
			screenLock.unlock();
			this.popupWrappers.removeClass( ACTIVE_CLASS );
		}
	}
}

export default new TeamPopup();
